var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-padding-bottom-10px custom-padding-left-10px custom-height-100p"},[_c('a-row',[_c('div',{staticClass:"title custom-flex"},[_c('div',{staticClass:"icon"}),_c('span',[_vm._v("订单趋势")])])]),_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{ref:"orderChart",staticStyle:{"height":"220px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }